// @flow
import moment from 'moment';
import mergeDateAndTime from '../../../helpers/mergeMoment';

type SpotConstructorData = {
  startAt: moment;
  duration: number;
  reference: string;
  campaignReference: ?string;
  reach: ?number;
};

class Spot {

  startAt: moment;
  reach: ?number;
  duration: number;
  reference: string;
  campaignReference: ?string;

  constructor({ startAt, reach, duration, reference, campaignReference }: SpotConstructorData) {
    this.startAt = startAt;
    this.reach = reach;
    this.duration = duration;
    this.reference = reference;
    this.campaignReference = campaignReference;
  }

  withStartingDate(date: moment): Spot {
    const mergedDate = mergeDateAndTime(date, this.startAt);
    return new Spot({ ...this, startAt: mergedDate });
  }

  withStartingTime(time: moment): Spot {
    const mergedTime = mergeDateAndTime(this.startAt, time);
    return new Spot({ ...this, startAt: mergedTime });
  }

  withDuration(duration: number): Spot {
    return new Spot({ ...this, duration });
  }

  withCampaignReference(campaignReference: ?string): Spot {
    return new Spot({ ...this, campaignReference });
  }

  hasReach(): boolean {
    return this.reach === 0 || Boolean(this.reach);
  }

  compareByDate(spot: Spot): number {
    if (this.startAt.isSame(spot.startAt)) {
      return 0;
    }

    return this.startAt.isBefore(spot.startAt) ? -1 : 1;
  }

  isSameAs(spot: Spot): boolean {
    return this.reference === spot.reference;
  }

  toJSON(): Object {
    const startAt = this.startAt.format('YYYY-MM-DDTHH:mm:ss');

    return {
      ...this,
      startAt,
    };
  }

  static parse({ startAt, reach, duration, reference, campaignReference }: Object) {
    return new Spot({
      startAt: moment(startAt),
      reach,
      duration,
      reference,
      campaignReference,
    });
  }

}

export default Spot;



// WEBPACK FOOTER //
// ./src/common/modules/spots/domain/Spot.js